import { ICONS } from 'Components/utils/icon/icons';
import {
  NO_OUTSIDE_FACILITY_ICON_ID,
  NO_VIEW_ICON_ID,
} from 'Components/widgets/accommodation-room/infos/AccommodationRoomInfos.utils';
import { uniqBy, get } from 'lodash';
import { t } from 'Src/i18n';

function allAccommodationsHaveTheSameCategory(accommodationSet) {
  const { accommodations } = accommodationSet;
  const { categoryId: firstAccommodationCategory } = accommodations[0];
  return accommodations.every(
    ({ categoryId: currentCategoryId }) => currentCategoryId === firstAccommodationCategory,
  );
}

//check if it already has the caregoryId
function getCategoryIndex(categorizedAccommodationsArray, currentCategoryId) {
  return categorizedAccommodationsArray.findIndex(
    ({ categoryId }) => currentCategoryId === categoryId,
  );
}
//if not ie == -1

function addNewComfortToArray(categorizedAccommodationsArray, accommodationSet) {
  const firstAccommodation = accommodationSet.accommodations[0];

  const viewsAvailable = [];
  const outsideFacilitiesAvailable = [];
  const roomTypesAvailable = [];

  const { accommodations } = accommodationSet;
  const noView = {
    id: NO_VIEW_ICON_ID,
    label: t('booking.accommodation.roomFinder.noViewLabel'),
  };
  const no_outside_facility = {
    id: NO_OUTSIDE_FACILITY_ICON_ID,
    label: t('booking.accommodation.roomFinder.noFacilitiesLabel'),
  };
  accommodations.forEach(({ view, outsideFacilities, roomType }) => {
    viewsAvailable.push(view || noView);
    outsideFacilitiesAvailable.push(outsideFacilities?.[0] || no_outside_facility); //array that always contain one element
    roomType && roomTypesAvailable.push({ id: roomType });
  });
  const { id, categoryId } = firstAccommodation;

  categorizedAccommodationsArray.push({
    id,
    categoryId,
    availableFilters: {
      view: viewsAvailable
        ? uniqBy(viewsAvailable, 'id').map((view) => ({
            ...view,
            firstAlternativeId: accommodationSet.id,
            icon: ICONS[get(view, 'id')] || ICONS.TRIDENT,
          }))
        : [], //HERE
      outsideFacilities: outsideFacilitiesAvailable
        ? uniqBy(outsideFacilitiesAvailable, 'id').map((outsideFacility) => ({
            ...outsideFacility,
            firstAlternativeId: accommodationSet.id,
            icon: ICONS[get(outsideFacility, 'id')] || ICONS.TRIDENT,
          }))
        : [],
      roomType: roomTypesAvailable
        ? uniqBy(roomTypesAvailable, 'id').map((roomType) => ({
            ...roomType,
            firstAlternativeId: accommodationSet.id,
            icon: ICONS[get(roomType, 'id')] || ICONS.TRIDENT,
          }))
        : [],
    },
  });
}

function getFiltersAndAlternativesByComfort(accommodationSets) {
  const categorizedAccommodationsArray = [];
  //Remove the accommodationSets with different comfort categories (ie : deluxe + superieur)
  const filteredAccommodationSets = accommodationSets.filter((accommodationSet) =>
    allAccommodationsHaveTheSameCategory(accommodationSet),
  );
  filteredAccommodationSets.map((accommodationSet) => {
    const { categoryId } = accommodationSet.accommodations[0];
    const categoryIndex = getCategoryIndex(categorizedAccommodationsArray, categoryId);
    const categoryNotListed = categoryIndex === -1;
    if (categoryNotListed) {
      addNewComfortToArray(categorizedAccommodationsArray, accommodationSet);
    } else {
      accommodationSet.accommodations.forEach(({ view, outsideFacilities, roomType }) => {
        //check if the views are NOT already listed in the available filters => we add them
        if (
          view &&
          !categorizedAccommodationsArray[categoryIndex].availableFilters.view.some(
            ({ id }) => id === view.id,
          )
        ) {
          categorizedAccommodationsArray[categoryIndex].availableFilters.view.push({
            ...view,
            firstAlternativeId: accommodationSet.id,
            icon: ICONS[get(view, 'id')] || ICONS.TRIDENT,
          });
        }

        if (
          outsideFacilities.length > 0 &&
          !categorizedAccommodationsArray[categoryIndex].availableFilters.outsideFacilities.some(
            ({ id }) => id === outsideFacilities[0].id,
          )
        ) {
          categorizedAccommodationsArray[categoryIndex].availableFilters.outsideFacilities.push({
            ...outsideFacilities[0],
            firstAlternativeId: accommodationSet.id,
            icon: ICONS[get(outsideFacilities[0], 'id')] || ICONS.TRIDENT,
          });
        }
        if (
          roomType &&
          !categorizedAccommodationsArray[categoryIndex].availableFilters.roomType === roomType.id
        ) {
          categorizedAccommodationsArray[categoryIndex].availableFilters.roomType.push({
            ...roomType,
            firstAlternativeId: accommodationSet.id,
            icon: ICONS[get(roomType, 'id')] || ICONS.TRIDENT,
          });
        }
      });
    }
  });

  return categorizedAccommodationsArray;
}
export { getFiltersAndAlternativesByComfort };
